<template>
	<div class="embed-block">
		<!--
			The custom element (e.g. <mediaos-form id="123">) is injected here.
			On the public site the MediaOS global script (mos-scripts.com/a/main.js)
			activates it at runtime. With nothing configured, render nothing — the
			editor's admin variant handles the empty / picker state.
		-->
		<div v-if="renderedTag" class="embed-block__host" v-html="renderedTag"></div>
	</div>
</template>

<script>
/**
 * EmbedBlock.vue — public renderer
 * ─────────────────────────────────
 * Renders the live MediaOS custom element on the public site so the global
 * script can activate it. Stores:
 *   - componentId  catalog entry id (e.g. 'mediaos-form')
 *   - embedAttrs   JSON-stringified { attr-key: value } object
 *
 * The CMS editor swaps in `embedBlockAdmin.vue`, which lets the user pick a
 * component, configure props, and preview the live embed in-canvas.
 */

import { findComponentById } from '@/websites/embeds/embedCatalog.js';
import { buildEmbedTag } from '@/websites/cms/blocks/shared/blockUtils.js';

export default {
	name: 'EmbedBlock',

	props: {
		componentId: { type: String, default: '' },
		embedAttrs:  { type: String, default: '{}' }
	},

	computed: {
		catalogEntry: function () {
			return this.componentId ? findComponentById(this.componentId) : null;
		},

		parsedAttrs: function () {
			try {
				return JSON.parse(this.embedAttrs || '{}');
			} catch (e) {
				return {};
			}
		},

		/** Build the actual embed tag string for v-html injection (shared, key-validated). */
		renderedTag: function () {
			var entry = this.catalogEntry;
			if (!entry || !entry.tag) return '';
			return buildEmbedTag(entry.tag, this.parsedAttrs);
		}
	}
};
</script>

<style scoped>
.embed-block {
	position: relative;
}

.embed-block__host {
	width: 100%;
}
</style>
